import { useSetAtom as m, useAtomValue as o } from "jotai/index";
import { setSummaryButtonAtom as u, summaryButtonAtom as r } from "./index34.mjs";
const a = () => {
  const t = m(u);
  return {
    buttonSummary: o(r),
    setSummaryButton: t
  };
};
export {
  a as useSummaryButton
};
